import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@components/Nav/Header";
import SideNav from "@components/Nav/SideNav";
import MainContent from "@components/Layout/MainContent";
import useSegmentIdentify from "@hooks/useSegmentIdentify";

const AppLayout = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  useSegmentIdentify();

  const showSideNav = location.pathname !== "/payment-methods";

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  return (
    <div id="App" className="flex flex-col h-screen" data-testid="app-component">
      <Header onMenuClick={showSideNav ? () => setMobileNavOpen(true) : undefined} />
      <div className="flex flex-1 overflow-scroll" data-testid="app-layout-container">
        {showSideNav && (
          <SideNav mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
        )}
        <MainContent />
      </div>
    </div>
  );
};

export default AppLayout;